import React from 'react';

import FormSupervisorDetail  from 'components/Tvendo/Sale/QuotaBPartner/GoogleForm/Supervisor/SupervisorDetail/List.js';

export default function () {
  return <FormSupervisorDetail  />;
}